import { optionTitle_message } from './MessageOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let MessageOption: LazyOption = createLazyOption(
    {
        key: 'message',
        titleStringKey: optionTitle_message,
        searchTermsStringKey: optionTitle_message,
    },
    lazyFullModule,
    m => m.default
);
export default MessageOption;
